module.exports = __webpack_public_path__ + "static/blockchaindevelopment-52c729b92c53efa4288b8c1483998936.jpg";